export default __webpack_public_path__ + "static/Food_Label_Digital_Tear_Sheet-b0cf978e684ff0daae5e60755ad0e3cd.jpg";